import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { useParams } from 'react-router-dom';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetSeePermisions() {
  const { id } = useParams();
  return useQuery(['get-employess-permisions'], async () => {
    const res = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.TEAMS_PERMISIONS_API, {
        employee_id: id,
      })
    );
    return res.data;
  });
}
